import React from "react";
import { Dropdown } from "react-bootstrap";
import { Menu } from "react-feather";
import { Link } from "react-router-dom";
import { useAuth, handleLogout } from "context/auth";
import {
  useResponsive,
  handleChangeSidebarState,
} from "context/responsiveContext";
import useRoles from "customHooks/useRoles";

export default function Header() {
  const [auth, dispatchAuth] = useAuth();
  const [responsiveState, dispatchResponsive] = useResponsive();
  const { roles } = useRoles();
  return (
    <header className="header">
      <div className="app_container">
        <button
          type="button"
          className="header-menu"
          onClick={handleChangeSidebarState.bind(this, dispatchResponsive, {
            sidebarClass: responsiveState.sidebarClass,
          })}
        >
          <Menu width={40} height={40} />
        </button>
        <div className="logo">
          <Link to="/">
            <img
              src={`${process.env.PUBLIC_URL}/petra_logo_web.svg`}
              alt="اراضي البتراء"
              height={70}
            />
          </Link>
        </div>
        <ul className="links list-unstyled user-info">
          <li>
            <Dropdown>
              <Dropdown.Toggle
                className="dropdown-basic-user-info"
                style={{ display: "flex", alignItems: "center" }}
              >
                {/* <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/avatar.svg`}
                    width={50}
                    height={50}
                    alt="avatar"
                    className="header__avatar"
                  />
                </span> */}
                {auth?.userDetails?.roles[0].roleId === 3 && (
                  <span>
                    أهلا .. {auth?.userDetails?.details?.fullName?.trim()}
                  </span>
                )}
                {auth?.userDetails?.roles[0].roleId !== 3 && (
                  <span>
                    أهلا ..{" "}
                    {`${auth?.userDetails?.details?.firstName}
                       ${auth?.userDetails?.details?.lastName}`}
                  </span>
                )}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => handleLogout(dispatchAuth, roles.people)}
                >
                  تسجيل خروج
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li>
        </ul>
      </div>
    </header>
  );
}
